import React, { ReactElement } from 'react';
import FormHelperText, { FormHelperTextProps, FormHelperTextTypeMap } from '@mui/material/FormHelperText';
import { BpDesignSystem } from '../../types';

export type HelperTextProps<
  D extends React.ElementType = FormHelperTextTypeMap['defaultComponent'],
  P = {}
> = BpDesignSystem.PropsWithChildren<FormHelperTextProps<D, P> & { id?: string }>;

/**
 * @deprecated use FormHelperText instead
 */
export const HelperText = <D extends React.ElementType = FormHelperTextTypeMap['defaultComponent'], P = {}>({
  error,
  id,
  dataTest,
  children,
  ...rest
}: HelperTextProps<D, P>): ReactElement => (
  <FormHelperText error={!!error} data-test={dataTest} id={id ?? dataTest} {...rest}>
    {children}
  </FormHelperText>
);

export const getHelperText = (
  error?: boolean,
  helperText?: React.ReactNode,
  errorText?: React.ReactNode
): React.ReactNode => {
  if (error) return errorText ?? helperText;
  return helperText;
};
